// Block 1 E (47002): the reconciliation block of the ONE customer-payment drawer. Presentational: every value is a field the API sent (the order row's
// money net of returns and its collectable_cap, or the customer position snapshot); this block only lays them out. Lives in components/sale/ so the
// canonical Sale record / action drawers (audit 47010 sec. 5.4) can reuse it.
import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatMoneyPrecise } from '../../utils/format';

import { emoText } from '../../shell/EmojiIcons';
const EPS = 0.005;
const fmt2 = n => formatMoneyPrecise(Number(n) || 0);

export default function PaymentRecon({ recon }) {
  const { t: tn } = useTranslation('sales');
  if (!recon) return null;
  const row = (label, value, color) => (
    <div style={{ display: 'flex', justifyContent: 'space-between', gap: 20 }}>
      <span style={{ color: 'var(--muted)' }}>{emoText(label)}</span>
      <b style={{ fontVariantNumeric: 'tabular-nums', color: color || 'var(--ink)' }}>{value == null ? '—' : fmt2(value)}</b>
    </div>
  );
  const R = k => tn(`customerNet.recon.${k}`);
  // Every value below is a field the API sent (order row / customer position snapshot); the block only lays them out.
  return (
    <div data-testid="customer-pay-recon" style={{ marginBottom: 12, border: '1px solid var(--line)', borderRadius: 6, background: '#fff', padding: '9px 11px', fontSize: 11.5 }}>
      <div style={{ fontSize: 10.5, fontWeight: 700, color: 'var(--muted)', marginBottom: 6, textTransform: 'uppercase', letterSpacing: '.04em' }}>{emoText(recon.label)}</div>
      {recon.kind === 'order' && <>
        {row(R('ordered'), recon.ordered)}
        {recon.returned > EPS && row(R('returned'), recon.returned, '#b14a30')}
        {recon.returned > EPS && <div style={{ borderTop: '1px dashed var(--line)', marginTop: 3, paddingTop: 3 }}>{row(R('netOrder'), recon.netOrder)}</div>}
        {row(R('delivered'), recon.delivered, 'var(--muted)')}
        {row(R('remaining'), recon.remaining)}
        {recon.deposit > EPS && row(R('deposit'), recon.deposit, '#2563eb')}
        {row(R('ar'), recon.ar, '#c47d10')}
      </>}
      {recon.kind === 'orderless' && row(R('orderless'), recon.orderless, '#c47d10')}
      {recon.kind === 'customer' && <>
        {row(R('customerOwed'), recon.gross)}
        {recon.remaining > EPS && row(R('remaining'), recon.remaining)}
        {row(R('customerOnAccount'), recon.onAccount, '#7c3aed')}
        {recon.advances > EPS && row(R('customerAdvances'), recon.advances, '#2563eb')}
        {recon.refunds > EPS && row(R('customerRefunds'), recon.refunds, '#c47d10')}
      </>}
      {recon.kind === 'order' && recon.customerCap != null && recon.customerCap < recon.own - EPS && row(R('customerCap'), recon.customerCap, '#7c3aed')}
      <div style={{ marginTop: 6, paddingTop: 6, borderTop: '1px solid var(--line)', fontWeight: 700 }}>
        {row(R('collectable'), recon.collectable, recon.collectable > EPS ? '#166534' : 'var(--muted)')}
      </div>
      <div style={{ marginTop: 5, fontSize: 10, fontStyle: 'italic', color: '#94a3b8' }}>{R('foot')}</div>
      {recon.unavailable ? <div style={{ marginTop: 5, fontSize: 11, color: '#b14a30' }}>{R('unavailable')}</div>
        : recon.collectable <= EPS && <div style={{ marginTop: 5, fontSize: 11, color: '#7c3aed' }}>{R('nothing')}</div>}
    </div>
  );
}
